import range from 'lodash/range';

import {TWeekDay, TWeekStart} from '../types';

export const getWeekDays = (weekStart: TWeekStart): TWeekDay[] => {
  const weekDays = range(7).map((weekday) => ({
    weekday,
    isWeekend: weekday === 6 || weekday === 0,
  }));

  if (weekStart === 1) {
    const sundayItem = weekDays.shift();

    weekDays.push(sundayItem as TWeekDay);
  }

  return weekDays;
};
